export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Please check the required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["필수 입력사항을 확인 해주세요"])}
    }
  })
}
